var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddNewBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#CECECE",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 6.455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.717 7.545 18 10.833v6.894C18 18.43 17.431 19 16.73 19H9.74c-.702 0-1.27-.57-1.27-1.273V8.818c0-.703.568-1.273 1.27-1.273h4.977zm-1.676 3.592a.554.554 0 0 0-.554.554v1.412h-1.406a.554.554 0 0 0 0 1.109h1.409v1.408a.554.554 0 1 0 1.107 0v-1.41h1.407a.554.554 0 0 0 0-1.11l-1.41.003V11.69a.554.554 0 0 0-.553-.554zM14.895 5v1.273H7.271v8.909H6v-8.91C6 5.57 6.569 5 7.27 5h7.625z",
    fill: "#7C7C7C",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewBooking);
export default __webpack_public_path__ + "static/media/add-new-booking.31e90907767a3198f51458cd0b40b876.svg";
export { ForwardRef as ReactComponent };